import { RichText } from '@rumblefish/ui/Rumblefish23Theme';
import { StyledCaseStudySection, StyledTitle } from './CustomSection.styles';
import type { CaseStudyCustomSectionProps } from './CustomSection.types';

export const CaseStudyCustomSection = ({
  title,
  content,
  customTitle,
}: CaseStudyCustomSectionProps) => {
  const finalTitle = customTitle ?? title?.replace(/_/g, ' ');
  return (
    <StyledCaseStudySection noGap>
      {finalTitle && (
        <StyledTitle variant="display_xs">{finalTitle}</StyledTitle>
      )}
      {content && <RichText content={content} />}
    </StyledCaseStudySection>
  );
};
